import React from 'react'
import PropTypes from 'prop-types'
import CloseModalIcon from '../../../../static/icons/close-menu-icon.svg'

import { BodyScrollLock } from '../../styled'
import {
  ModalBackdrop,
  ModalDialog,
  ModalClose
} from './styles'

const Modal = ({
  children,
  dataTest,
  visible,
  onClose,
  modalWidth,
  modalHeight,
  modalTop
}) => {
  return (
    <>
      <ModalBackdrop visible={visible} onClick={onClose} data-test={`${dataTest}-modal-backdrop`} />
      <ModalDialog
        visible={visible}
        $modalWidth={modalWidth}
        $modalHeight={modalHeight}
        $modalTop={modalTop}
        data-test={`${dataTest}-modal-dialog`}
      >
        {onClose && (
          <ModalClose onClick={onClose}>
            <CloseModalIcon />
          </ModalClose>
        )}
        {children}
      </ModalDialog>
      <BodyScrollLock active={visible} />
    </>
  )
}

export default Modal

Modal.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.node,
  dataTest: PropTypes.string,
  visible: PropTypes.bool,
  modalWidth: PropTypes.string,
  modalHeight: PropTypes.string,
  modalTop: PropTypes.string
}
